import {StyleSheet} from "aphrodite";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LayoutTwoColumns} from "@khan/component-layout-two-columns";
import {mediaQueries} from "@khan/shared-styles";

interface Props {
    /**
     * The left component of this layout. Designed for use with images/figures but should be flexible.
     * This will be hidden on small screens.
     */
    leftComponent: React.ReactNode;
    /**
     * The right component of this layout. Designed for use with forms but should be flexible.
     * This will be full width on small screens.
     */
    rightComponent: React.ReactNode;
    /**
     * The CSS Grid column template for the grid layout. Defaults to "1fr 40%".
     */
    columnTemplate?: string;
    /**
     * Additional styles for the container.
     */
    style?: React.CSSProperties;
}

/**
 * A layout with two columns. On small screens (smOrSmaller), the content
 * is laid out "1fr 1fr", On xSmall screens (xsOrSmaller), the left component
 * is hidden. Columns have padding and max-widths, so the content is centered.
 */
export const ExtraInfoLayout = ({
    leftComponent,
    rightComponent,
    columnTemplate = "1fr 1fr",
    style,
}: Props) => {
    return (
        <LayoutTwoColumns
            firstColumn={leftComponent}
            secondColumn={rightComponent}
            style={[
                styles.container,
                style,
                {gridTemplateColumns: columnTemplate},
            ]}
            firstColumnStyle={styles.leftColumn}
            secondColumnStyle={styles.rightColumn}
        />
    );
};

const styles = StyleSheet.create({
    container: {
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",

        [mediaQueries.smOrSmaller]: {
            gridTemplateColumns: "100%",
        },
        justifyItems: "center",
    },
    leftColumn: {
        display: "none",
        width: "100%",
        [mediaQueries.mdOrLarger]: {
            display: "block",
            padding: `${spacing.xLarge_32}px ${spacing.large_24}px ${spacing.large_24}px`,
        },
        [mediaQueries.lgOrLarger]: {
            maxWidth: 480,
        },
    },
    rightColumn: {
        padding: `${spacing.xLarge_32}px ${spacing.large_24}px ${spacing.large_24}px`,
        width: "100%",
        [mediaQueries.lgOrLarger]: {
            width: 400,
        },
    },
});
